module.exports = __webpack_public_path__ + "assets/img/65p_316_3.225b212d.jpg";